import React from 'react'

type Props = {
    color?: string,
    size?: number
}

const HexagonBorder = (props: Props) => {
    const { color = 'white', size = '100%' } = props

    return (
        <svg
            fill={color}
            width={size}
            height={size}
            viewBox="8.68 6.24 131.64 149.53">
            <g /* filter="url(#filter0_di_914_16684)" */>
                <path
                    d="M70.5 7.3094C72.9752 5.88034 76.0248 5.88034 78.5 7.3094L136.318 40.6906C138.793 42.1197 140.318 44.7607 140.318 47.6188V114.381C140.318 117.239 138.793 119.88 136.318 121.309L78.5 154.691C76.0248 156.12 72.9752 156.12 70.5 154.691L12.6821 121.309C10.2069 119.88 8.68207 117.239 8.68207 114.381V47.6188C8.68207 44.7607 10.2069 42.1197 12.6821 40.6906L70.5 7.3094Z"
                    fill="white"
                />
                <path
                    d="M71.5 9.04145C73.3564 7.96966 75.6436 7.96965 77.5 9.04145L135.318 42.4226C137.174 43.4944 138.318 45.4752 138.318 47.6188V114.381C138.318 116.525 137.174 118.506 135.318 119.577L77.5 152.959C75.6436 154.03 73.3564 154.03 71.5 152.959L13.6821 119.577C11.8257 118.506 10.6821 116.525 10.6821 114.381V47.6188C10.6821 45.4752 11.8257 43.4944 13.6821 42.4226L71.5 9.04145Z"
                    stroke="url(#paint0_angular_914_16684)"
                    strokeWidth="4"
                />
                <path
                    d="M71.5 9.04145C73.3564 7.96966 75.6436 7.96965 77.5 9.04145L135.318 42.4226C137.174 43.4944 138.318 45.4752 138.318 47.6188V114.381C138.318 116.525 137.174 118.506 135.318 119.577L77.5 152.959C75.6436 154.03 73.3564 154.03 71.5 152.959L13.6821 119.577C11.8257 118.506 10.6821 116.525 10.6821 114.381V47.6188C10.6821 45.4752 11.8257 43.4944 13.6821 42.4226L71.5 9.04145Z"
                    stroke="url(#paint1_linear_914_16684)"
                    strokeWidth="4"
                />
            </g>
            <defs>
                <filter
                    id="filter0_di_914_16684"
                    x="0.682068"
                    y="0.237793"
                    width="147.636"
                    height="165.524"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_914_16684"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_914_16684"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="8" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect2_innerShadow_914_16684"
                    />
                </filter>
                <radialGradient
                    id="paint0_angular_914_16684"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(74.5 81) rotate(90) scale(76)">
                    <stop stopColor="#FBAA08" />
                    <stop offset="0.148069" stopColor="white" />
                    <stop offset="0.33036" stopColor="#FBAA08" />
                    <stop offset="0.481402" stopColor="white" />
                    <stop offset="0.64286" stopColor="#FBAA08" />
                    <stop offset="0.814735" stopColor="white" />
                    <stop offset="1" stopColor="#FBAA08" />
                </radialGradient>
                <linearGradient
                    id="paint1_linear_914_16684"
                    x1="74.5"
                    y1="-33"
                    x2="74.5"
                    y2="173.286"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7A105" stopOpacity="0.33" />
                    <stop offset="1" stopColor="#FBAA08" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export { HexagonBorder }
